import { render } from "./Address.vue?vue&type=template&id=907fd508&scoped=true&ts=true"
import script from "./Address.vue?vue&type=script&lang=ts"
export * from "./Address.vue?vue&type=script&lang=ts"

import "./Address.vue?vue&type=style&index=0&id=907fd508&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-settlement-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-907fd508"]])

export default __exports__